import { IError } from 'errors/types/IError'
import { ClientRequestServiceError } from 'shared/services/clientRequestService'

export const isClientRequestServiceError = (
  error: unknown,
): error is ClientRequestServiceError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof (error as ClientRequestServiceError).status === 'number'
  )
}

export const getErrorList = (error: unknown): IError[] => {
  if (!isClientRequestServiceError(error)) {
    if (typeof error === 'string') {
      return [{ message: error }]
    }
    return []
  }

  const { data } = error

  if (!data || typeof data !== 'object') {
    if (typeof data === 'string') {
      return [{ message: data }]
    }
    return []
  }

  if ('localized_messages' in data && Array.isArray(data.localized_messages)) {
    return data.localized_messages.map((err: unknown) => {
      if (typeof err === 'object' && err !== null && 'message' in err) {
        return {
          code: 'code' in err && typeof err.code === 'string' ? err.code : undefined,
          message: typeof err.message === 'string' ? err.message : String(err.message),
        }
      }
      return { message: String(err) }
    })
  }

  if ('messages' in data && Array.isArray(data.messages)) {
    return data.messages.map((err: unknown) => {
      if (typeof err === 'object' && err !== null && 'message' in err) {
        return {
          code: 'code' in err && typeof err.code === 'string' ? err.code : undefined,
          message: typeof err.message === 'string' ? err.message : String(err.message),
        }
      }
      return { message: String(err) }
    })
  }

  if ('message' in data && typeof data.message === 'string') {
    return [
      {
        code: 'code' in data && typeof data.code === 'string' ? data.code : undefined,
        message: data.message,
      },
    ]
  }

  return [{ message: String(data) }]
}

export default getErrorList
